import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=c137312c&scoped=true"
import script from "./AreYouSure.vue?vue&type=script&lang=ts"
export * from "./AreYouSure.vue?vue&type=script&lang=ts"
import style0 from "./AreYouSure.vue?vue&type=style&index=0&id=c137312c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c137312c",
  null
  
)

export default component.exports